import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const aberdeenSdFaqs = [
  { q: "How do I get an expedited passport in Aberdeen, South Dakota?", a: "Aberdeen residents can use Fast Passport Center for 2-9 day expedited processing. Submit your application, visit a local acceptance facility, then ship documents overnight. We handle agency submission — no trip to Minneapolis required." },
  { q: "Where is the nearest passport agency to Aberdeen SD?", a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 290 miles east of Aberdeen via I-29. It requires an appointment for genuine emergencies only. Fast Passport Center eliminates that trip." },
];

const aberdeenSdServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function AberdeenSDPage() {
  return (
    <>
      <CitySEOHead
        city="Aberdeen"
        state="South Dakota"
        stateAbbr="SD"
        route="/cities/aberdeen-sd"
        title="Emergency Passport Aberdeen, SD — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Aberdeen, South Dakota. Serving Brown County, Groton, Redfield, Ipswich, and Webster. As fast as 24 hours — no Minneapolis agency trip needed."
        geoPlacename="Aberdeen, South Dakota"
        geoPosition="45.4647;-98.4865"
        faqs={aberdeenSdFaqs}
        servicesSchema={aberdeenSdServices}
        statePageName="South Dakota"
        statePageRoute="/states/south-dakota"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <ServicesSection />
        <HowItWorksSection />
        <LocalAreaSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}